import gql from 'graphql-tag';
// import { SIMPLE_FIELD_TYPE_CONNECTION } from './SimpleFieldTypeConnection.gql';
import { REFERENCE_FIELD_TYPE_CONNECTION } from './ReferenceFieldTypeConnection.gql';
import { CUSTOM_SIMPLE_FIELD_TYPE_CONNECTION } from './CustomSimpleFieldTypeConnection.gql';

export const FORM_SECTION_TYPE = gql`
  ${CUSTOM_SIMPLE_FIELD_TYPE_CONNECTION}, ${REFERENCE_FIELD_TYPE_CONNECTION}
  fragment FormSectionType on FormSectionType {
    id
    title
    editable
    simplefield {
      ...Custom_SimpleFieldTypeConnection
    }
    referencefield {
      ...ReferenceFieldTypeConnection
    }
    sequence
  }
`;
